import React, { useState } from "react";
import { TooltipButton } from "@/components/common/TooltipButton";
import { railGlyphPath, useGlyphMorph } from "./glyphMorph";

const MS_PER_STEP = 320;

interface RailToggleProps {
  isOpen: boolean;
  onToggle: () => void;
}

/// Hovered while open, the logo folds into a triangle pointing left; closing
/// the rail turns it to point right (`.rail-toggle--closed`).
export const RailToggle: React.FC<RailToggleProps> = ({ isOpen, onToggle }) => {
  const [hovered, setHovered] = useState(false);
  // An expand click leaves the pointer on the toggle; the logo comes back anyway.
  const [held, setHeld] = useState(false);
  const pathRef = useGlyphMorph(
    !isOpen || (hovered && !held) ? 2 : 0,
    railGlyphPath,
    MS_PER_STEP,
  );
  const label = isOpen ? "Collapse menu" : "Expand menu";
  const leave = () => {
    setHovered(false);
    setHeld(false);
  };
  return (
    <TooltipButton
      title={label}
      aria-label={label}
      // Open, the mycorr.app link slides in where a right-hand tooltip sits.
      placement={isOpen ? "bottom" : "right"}
      onClick={() => {
        setHeld(!isOpen);
        onToggle();
      }}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={leave}
      onFocus={(e) => setHovered(e.currentTarget.matches(":focus-visible"))}
      onBlur={leave}
      variant="default"
      size="md"
      className={`logo-button rail-toggle${isOpen ? "" : " rail-toggle--closed"}`}
    >
      <svg viewBox="0 0 48 48" className="rail-toggle__glyph" aria-hidden>
        <path
          ref={pathRef}
          fill="none"
          stroke="currentColor"
          strokeWidth={4}
          strokeLinejoin="bevel"
        />
      </svg>
    </TooltipButton>
  );
};
